module.exports = __webpack_public_path__ + "media/images/app/testimonials/arrow-e0207be56eee8f8da2282b02361374fd.webp";